import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { Home } from './pages/Home';
import { HowIWasBuilt } from './pages/HowIWasBuilt';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}

function LanguageRedirect() {
  const { i18n } = useTranslation();
  const browserLang = i18n.language?.startsWith('en') ? 'en' : 'es';
  return <Navigate to={`/${browserLang}`} replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-bg-primary text-text-primary">
        <Navbar />
        <Routes>
          <Route path="/" element={<LanguageRedirect />} />
          <Route path="/:lang" element={<Home />} />
          <Route path="/:lang/how-i-was-built" element={<HowIWasBuilt />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
